var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"text-xxs",attrs:{"title":("" + _vm.display)}},[_vm._v("\n\t("+_vm._s(_vm.code ? _vm.code : _vm.offset)+")\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3756c579","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserTimezone.vue
// module id = null
// module chunks = 